import {Button, Divider, Form, Input, notification, Upload} from "antd";
import {DatePicker, JalaliLocaleListener} from "antd-jalali";
import locale from "antd/es/date-picker/locale/fa_IR";
import React, {useContext, useState} from "react";
import {validateIranianCompanyNationalCode, validateIranianMobile, validateIranianNationalCode} from "./validation";
import {FormProps} from "./types";
import {PictureOutlined, UploadOutlined} from "@ant-design/icons";
import {RcFile} from "antd/es/upload/interface";
import AuthContext from "../../utilis/contexts/AuthContext";

const {TextArea} = Input;
const LegalPersonForm = ({onConfirm,loading}: FormProps) => {
    const [date, setDate] = useState<string | null>(null);
    const [fileBase64, setFileBase64] = useState<string | null>(null);
    const authContext=useContext(AuthContext)
    const [form] = Form.useForm();
    const handleSubmit = (value: any) => {

        if(!fileBase64){
            notification['error']({
                message: 'فایل درخواست را انتخاب کنید',
                duration: 120
            });
            return;
        }
        const data = {
            Name: value.name,
            Subject: value.subject,
            BirthDate: date,
            CompanyNationalCode:value.companyNationalCode,
            NationalCode: value.nationalCode,
            CompanyName:value.companyName,
            Mobile: value.mobile,
            Attachment:fileBase64,
        }
        onConfirm(data)
    }


    const getBase64 = (file: RcFile): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });

    const handleBeforeUpload = async (file: RcFile): Promise<boolean> => {
        const isPdf = file.type === 'application/pdf';
        const isTif = file.type === 'image/tiff' || file.name.endsWith('.tif') || file.name.endsWith('.tiff');
        if (!isPdf && !isTif){
            notification['error']({
                message: 'تنها مجاز به ارسال فایل با فرمت tif , pdf می باشید.',
                duration: 120
            });
            return false;
        }
        const base64 = await getBase64(file);
        setFileBase64(base64);
        return false; // Prevent upload
    };
    return <div>
        <JalaliLocaleListener/>
        <Form

            name="realForm"
            className="w-full grid grid-cols-2 gap-2"
            layout='vertical'
            onFinish={handleSubmit}
            form={form}
            initialValues={{
                mobile: authContext?.user?.cellphone || '',
                name: authContext?.user?.name || '',
                birthDate: '',
                subject: '',
                nationalCode: '',
                address: ''

            }}

            autoComplete="off" scrollToFirstError={true}
        >
            <Form.Item
                className="col-span-2"
                label="عنوان شرکت"
                name="companyName"
                rules={[{required: true, message: 'عنوان شرکت الزامی است.'}]}
            >
                <Input placeholder="عنوان شرکت را وارد کنید." size="large"/>
            </Form.Item>
            <Form.Item
                className="col-span-2"
                label="نام مالک شرکت"
                name="name"
                rules={[{required: true, message: 'نام مالک شرکت الزامی است.'}]}
            >
                <Input placeholder="نام مالک شرکت را وارد کنید." size="large"/>
            </Form.Item>
            <Form.Item
                label="شماره موبایل مالک"
                name="mobile"
                rules={[
                    {required: true, message: 'شماره موبایل مالک شرکت الزامی است.'},
                    {validator: validateIranianMobile},
                ]}
            >
                <Input placeholder="شماره موبایل مالک را وارد کنید" type="tel" size="large"/>
            </Form.Item>
            <Form.Item
                label="شناسه ملی شرکت"
                name="companyNationalCode"
                rules={[
                    {required: true, message: 'شناسه ملی شرکت الزامی است.'},
                    {validator: validateIranianCompanyNationalCode},
                ]}
                className="col-span-1"
            >
                <Input
                    type="tel"
                    placeholder="شناسه ملی شرکت را وارد کنید"
                    className="w-full"
                    size="large"
                />
            </Form.Item>
            <Form.Item
                label=" کدملی مالک"
                name="nationalCode"
                rules={[
                    {required: true, message: 'کدملی مالک شرکت الزامی است.'},
                    {validator: validateIranianNationalCode},
                ]}
                className="w-full"
            >
                <Input
                    type="tel"
                    placeholder="کد ملی مالک را وارد کنید"
                    className="w-full"
                    size="large"
                />
            </Form.Item>

            <Form.Item
                className="col-span-1"
                label=" تاریخ تولد  مالک"
                name="birthDate"
                rules={[{required: true, message: 'تاریخ تولد الزامی است.'}]}
            >
                <DatePicker
                    format="YYYY/MM/DD"
                    onChange={(value: any, persian: any) => {
                        setDate(persian);
                    }}
                    className="w-full"
                    size="large"
                    nextIcon={<></>}
                    locale={locale}
                />
            </Form.Item>
            <Form.Item
                className="col-span-2"
                label="موضوع درخواست"
                name="subject"
                rules={[{required: true, message: 'موضوع درخواست الزامی است.'}, {
                    min: 10,
                    message: 'موضوع درخواست حداقل باید 10 کاراکتر باشد'
                }]}
            >
                <TextArea
                    maxLength={500}
                    placeholder="موضوع درخواست را وارد کنید"
                    className="w-full"
                    size="large"
                />
            </Form.Item>

            <div className="col-span-2">
                <Upload  accept=".pdf,.tif,.tiff" className="w-full" maxCount={1} beforeUpload={handleBeforeUpload} showUploadList={true}>
                    <Button className="flex w-full bg-gray-100 rounded-lg  justify-center items-center flex-col">
                        فایل درخواست
                        <UploadOutlined/>
                    </Button>
                </Upload>
            </div>
            <div className="col-span-2">
                <Divider/>
            </div>
            <Form.Item className="col-span-2">
                <Button loading={loading} className="w-full" size="large" type="primary" htmlType="submit">ثبت
                    اطلاعات</Button>
            </Form.Item>
        </Form>
    </div>
}
export default LegalPersonForm;